'use strict';

var define = require('define-properties');

var implementation = require('./implementation');

var getPolyfill = require('./polyfill');

var shim = require('./shim');

define(implementation, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = implementation;